/**
 * Returns the `redirect` search param if it is a safe internal path, otherwise `undefined`.
 * Rejects absolute / protocol-relative URLs (`//wylaaan.com`, `/\hugoat.com`) to avoid open redirects.
 */
export const getSafeRedirectPath = (search: unknown): string | undefined => {
  const value = (search as { redirect?: unknown } | undefined)?.redirect;

  if (typeof value !== 'string' || !value.startsWith('/')) {
    return undefined;
  }

  if (value.startsWith('//') || value.startsWith('/\\') || value.startsWith('/login')) {
    return undefined;
  }

  return value;
};
